import React, { useState, useEffect } from "react";
import { useDataWithRoute, useTitleFromComponent } from "../../../../utils/hooks";
import {Card} from "reactstrap";
import { useVsiAppContext } from "../../../../stores/VsiApp";
import { VsiBubble, VsiH4 } from "../../../../styled/App.styled";
import { useSearchParams } from "react-router-dom";
import Stockchart from "../../../../components/Stockchart";
import { formatStockChartConfig } from "../../../../utils/Helpers";
import { enterpriseTrendColors } from "../../../../utils/chartUtils";
import Grid from "../../../../components/Grid";
import { databaseServerTrends } from "../../../../utils/gridColumnDefs/databases/server/dbServerTrends";

export default function DatabaseServerTrend ({title}) {
    const [searchParams] = useSearchParams();
    const instanceName = searchParams.get('instance_name') ?? '';
    const deviceType = searchParams.get('device_type') ?? '';

    useTitleFromComponent(`${instanceName} / ${title}`);

    const { theme, client, periodId } = useVsiAppContext();

    const [data, {isLoading}] = useDataWithRoute(`/api/v6/report/database_data_files_proc?database_instance_name=${instanceName}&device_type_code=${deviceType}&client_id=${client.clientId}&period_id=${periodId}`);
    const [formattedChartData, setFormattedChartData] = useState([]);
    const [gridData, setGridData] = useState([]);

    useEffect(() => {
      const calcedData = (data?.recordsets?.[0] ?? []);

      const formattedData = formatStockChartConfig(calcedData, [
        {
          name: 'Free',
          field: 'free',
          dataLabels: {format: '{point.y:,.0f}'},
          tooltip: {pointFormat: '{series.name}: <b>{point.y:,.0f}</b>'},
        },
        {
          name: 'Used',
          field: 'used',
          dataLabels: {format: '{point.y:,.0f}'},
          tooltip: {pointFormat: '{series.name}: <b>{point.y:,.0f}</b>'},
        },
        {
          name: 'Allocated',
          field: 'allocated',
          dataLabels: {format: '{point.y:,.0f}'},
          tooltip: {pointFormat: '{series.name}: <b>{point.y:,.0f}</b>'},
        },
      ]);

      setFormattedChartData(formattedData.series);
      setGridData(calcedData);

    }, [data]);

  return (
        <Card className={`report-card p-2 nav-card-${theme}`}>
            <VsiH4>Database Server Trend - {instanceName}</VsiH4>
          <VsiBubble>
            <Stockchart series={formattedChartData}
                        saveParams={{
                          instanceName,
                          deviceType
                        }}
                        config={
              {
                colors: enterpriseTrendColors,
                yAxis: {
                  title: {
                    text: 'GiB'
                  },
                }
              }
            }/>
          </VsiBubble>
          <VsiBubble>
            <Grid addStyle
                  data={gridData}
                  isLoading={isLoading}
                  columnDefs={databaseServerTrends}/>
          </VsiBubble>
        </Card>
  )
}
